function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

/* =========================
   HOME：最新20点 → ランダム8点
========================= */
function initHomeNewArrivalsRandom() {
  const grid = document.querySelector(
    '[data-new-arrivals-home="true"]'
  );

  if (!grid) return;
  if (grid.dataset.randomized === 'true') return;

  grid.dataset.randomized = 'true';

  const items = Array.from(
    grid.querySelectorAll(':scope > .grid__item')
  );

  if (!items.length) return;

  const productsToShow =
    Number(grid.dataset.productsToShow) || 8;

  // 最新20点の番号をランダムに並べる
  const indexes = items.map((_, index) => index);
  shuffleArray(indexes);

  // ランダムに8点選ぶ
  const selected = new Set(
    indexes.slice(0, productsToShow)
  );

  // DOMの順番は触らず、選ばれた8点だけ表示
  items.forEach((item, index) => {
    item.style.display = selected.has(index) ? '' : 'none';
  });
}

/* =========================
   VIEW ALL：全商品ランダム
========================= */
function initNewArrivalsRandom() {
  const path = window.location.pathname.replace(/\/$/, '');

  if (path !== '/collections/new-arrivals') return;

  const grid = document.querySelector('#product-grid');

  if (!grid) return;
  if (grid.dataset.randomized === 'true') return;

  grid.dataset.randomized = 'true';

  const items = Array.from(
    grid.querySelectorAll(':scope > .grid__item')
  );

  if (!items.length) return;

  const perPage =
    Number(grid.dataset.displayPerPage) || 24;

  shuffleArray(items);

  items.forEach((item) => {
    grid.appendChild(item);
  });

  // Shopify標準ページネーションを削除
  const oldPagination =
    document.querySelector('.pagination-wrapper');

  if (oldPagination) oldPagination.remove();

  let currentPage = 1;

  const totalPages =
    Math.ceil(items.length / perPage);


  function showPage(page) {
    currentPage = page;

    const start = (page - 1) * perPage;
    const end = start + perPage;

    items.forEach((item, index) => {
      item.hidden =
        !(index >= start && index < end);
    });

    renderPagination();
  }


  function renderPagination() {
    const existing =
      document.querySelector(
        '#new-arrivals-pagination'
      );

    if (existing) existing.remove();

    if (totalPages <= 1) return;

    const nav =
      document.createElement('div');

    nav.id = 'new-arrivals-pagination';
    nav.className = 'pagination-wrapper';

    const list =
      document.createElement('ul');

    list.className =
      'pagination__list list-unstyled';


    for (
      let page = 1;
      page <= totalPages;
      page++
    ) {
      const li =
        document.createElement('li');

      const button =
        document.createElement('button');

      button.type = 'button';
      button.textContent = page;

      button.className =
        'pagination__item' +
        (page === currentPage
          ? ' pagination__item--current'
          : '');

      button.addEventListener(
        'click',
        () => {
          showPage(page);

          window.scrollTo({
            top:
              grid.getBoundingClientRect().top +
              window.scrollY -
              120,
            behavior: 'smooth'
          });
        }
      );

      li.appendChild(button);
      list.appendChild(li);
    }

    nav.appendChild(list);
    grid.after(nav);
  }

  showPage(1);
}


/* =========================
   START
========================= */
function initNewArrivals() {
  initHomeNewArrivalsRandom();
  initNewArrivalsRandom();
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    initNewArrivals
  );
} else {
  initNewArrivals();
}